import { PaymentMethodFormProvider } from "./PaymentMethodFormProvider";
import {
  NameInputField,
  RoundingFieldSet,
  EnabledFormInput,
  AssignToTerminalInputField,
} from "./components";

export interface PaymentMethodFormProps {}

export const PaymentMethodForm = ({}: PaymentMethodFormProps) => {
  return null;
};

PaymentMethodForm.Provider = PaymentMethodFormProvider;
PaymentMethodForm.NameInputField = NameInputField;
PaymentMethodForm.EnabledFormInput = EnabledFormInput;
PaymentMethodForm.RoundingFieldSet = RoundingFieldSet;
PaymentMethodForm.AssignToTerminalInputField = AssignToTerminalInputField;
